<template lang="">
	<div>
		<c-r-m-nav-cell
			ref="navcell" 
			:crm-type="crmType" 
			route-type="read"
			@on-handle="listHeadHandle"/>
		<div class="detailtop">
			<div style="margin-top: 10px; display: flex;">
				<div class="left-box">
					<div
						style="display: flex;justify-content: center;align-items: center;height: 50px;font-weight: 600;font-size: 14px;">
						编辑详情</div>
					<div 
						class="left-item" 
						v-for="(item,index) in leftList"
						:key="index"
						@click="onLeftHandle(item)">
						<span>{{item.name}}</span>
						<i class=" el-icon-arrow-right"></i>
					</div>
				</div>
				<div class="right-box">
					<component
						ref="component"
						:is="tabName" 
						:crm-type="crmType" 
						:id="id" 
						:detail="detailData"
						@handle="infoHandle"  />
				</div>
			</div>
		</div>
		
			
		<!-- dialog弹窗 -->
		<dialog-form
			:dialog-visible="dialogForm"
			:title="title"
			ref="crmform"  
			:crm-type="crmType"
			:fields-data = "fieldsData"
			:action="action"
			:form-data="formData"
			@close = "closeDialog"
			@save-dialog="saveDialog">
		</dialog-form>
	</div>
</template>
<script>
	import moment from 'moment'
	import { mapGetters } from 'vuex'
	import CRMNavCell from '@/components/table/new/CRMNavCell'
	import {
		CRMBaseInfo,
		CRMContractLog,
		CRMContractFinance,
		CRMContractComplain,
		CRMActionRecord
	} from '@/components/table/new/contract'
	
	import {DialogForm} from '@/components/FromData'
	import {
		crmContractRead,
		crmContractLogSave,
		crmContractcomplainSave,
		crmContractClose
	} from '@/api/contract/contract'
	export default {
		name: "app",
		components: {
			CRMNavCell,
			DialogForm,
			CRMBaseInfo,
			CRMContractLog,
			CRMContractFinance,
			CRMContractComplain,
			CRMActionRecord
		},
		computed: {
			...mapGetters(['allAuth'])
		},
		data() {
			return {
				crmType:"contract",
				tabCurrentName: 'basicinfo',
				
				// 基本信息
				loading:false,
				list: [],
				id:0,
				
				// 左侧操作按钮
				leftList:[
					{ "name":"添加服务日志" , "type":"save_log" },
					{ "name":"添加客户反馈" , "type":"save_complain" },
					{ "name":"停止服务" , "type":"close" }
				],
				
				type:'',
				radio:true,
				
				// dialog弹窗
				dialogForm:false,
				title:"",
				dialogType:"",
				fieldsData:[],
				action:{ type: '',relevant:'',actiontype:'' },
				formData:{},
				detailData:{},
			}
		},
		computed: {
			tabName() {
				if (this.tabCurrentName == 'basicinfo') {
					return 'c-r-m-base-info'
				}else if (this.tabCurrentName == 'record') {
					return 'c-r-m-contract-log'
				}else if (this.tabCurrentName == 'finance') {
					return 'c-r-m-contract-finance'
				}else if (this.tabCurrentName == 'complain') {
					return 'c-r-m-contract-complain'
				}else if (this.tabCurrentName == 'action') {
					return 'c-r-m-action-record'
				}
				return ''
			}
		},
		mounted() {
			this.tabCurrentName = this.$route.params.tabname
			this.id = this.$route.params.id
			this.getbadgeNum()
			this.getDetial()
		},
		methods: {
			// 获取详情
			getDetial(){
				crmContractRead({
					id: this.$route.params.id
				})
				  .then(res => {
				    this.detailData = res.data
				  })
				  .catch(err => {
				    if (err && err.code == 102) {
				      this.hasRequestAuth = false
				    }
				    this.loading = false
				  })
			},
			
			// 获取角标
			getbadgeNum(){
				this.$store.commit('emptybadgeByContract')
				this.$store.dispatch('GetContractBadgeNum', this.id)
			},
			
			//* * tab标签点击 */
			listHeadHandle(tname) {
				// console.log(tabName);
				this.tabCurrentName = tname
				this.$router.push({
					path:"/contract/read/"+tname+"/"+this.$route.params.id
				}) 
				this.id = this.$route.params.id
			},
			
			onLeftHandle(item){
				switch (item.type){
					case "save_log":
						this.title = "新增服务日志"
						this.action = { type: 'save',relevant:'log' ,actiontype:12}
						this.dialogForm = true
						break;
						
					case "save_complain":
						this.title = "新增客户反馈"
						this.action = { type: 'save',relevant:'contractcomplain' ,actiontype:17}
						this.dialogForm = true
						break;	
					
					case "close":
						this.title = "停止服务"
						this.action = { type: 'save',relevant:'close' ,actiontype:19}
						this.dialogForm = true
						break;	
				}
			},
			
			// 弹窗操作
			closeDialog(){
				this.title = ""
				this.dialogForm = false
				this.formData = {}
			},
			
			// 保存操作
			saveDialog(item){
				let data = item.data
				data["contract_id"] = this.$route.params.id
				let request
				if(item.type == "save_log"){
					request = crmContractLogSave
					data["customer_id"] = this.detailData.customer_id
				}else if(item.type == "save_contractcomplain"){
					request = crmContractcomplainSave
				}else if(item.type == "save_close"){
					request = crmContractClose
				}
				
				request(data)
					.then(res => {
						this.$message.success(res.data)
						// 修改角标
						if(item.type == "save_log"){
							this.$store.commit('incrementByContract','record')
						}
						if(item.type == "save_contractcomplain"){
							this.$store.commit('incrementByContract','complain')
						}
						this.closeDialog()
						this.$refs.component.getBaseInfo()
						this.getDetial()
					})
			},
			
			
			
			infoHandle(item){
				this.getDetial()
			}
		}
	};
</script>
<style scoped>
	.detailtop{
		display: flex;
		background-color: #f2f2f2; 
		align-items: center; 
		flex-direction: column; 
		min-height: 100vh;
	}
	.content_item {
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 12px;
	}

	.content_box {
		height: 40px;
		/* background-color: #eeeff4; */
		display: flex;
		align-items: center;
		padding: 0 10px;
	}

	.titel_item {
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 14px;
		font-weight: 550;
	}

	.titel_box {
		height: 50px;
		background-color: #eeeff4;
		display: flex;
		align-items: center;
		padding: 0 10px;
	}

	.lianxiren_add {
		margin: 0 5px;
		color: #fff;
		background-color: #b5060d;
		font-size: 12px;
		padding: 5px 10px;
	}

	.lianxirem_title {
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 18px;
		font-weight: 600;
	}

	.lianxiren {
		height: 50px;
		align-items: center;
		/* border-bottom: 1px solid #f2f2f2; */
		display: flex;
		justify-content: space-between;
		background-color: #fff;
		margin-top: 20px;
		padding: 0 10px;
	}

	

	.left-item {
		border-radius: 3px;
		border: 1px solid #f2f2f2;
		margin: 3px 5px;
		font-size: 13px;
		padding: 10px 15px;
		display: flex;
		justify-content: space-between;
		color: #8d8d8d;
		cursor: pointer;
	}
	.left-item:hover{
		background-color: #f36b6b;
		color: #fff;
	}

	.box {
		width: 1200px;
	}

	
	/* /deep/ .el-tabs__item.is-top:last-child{
		padding-right: 20px !important;
	}
	/depp/ .el-tabs--top .el-tabs__item.is-top:nth-child(2){
		padding-left: 20px !important;
	} */

	.nav_item {
		color: #545454;
		font-weight: 600;
	}

	.left-box {
		width: 200px;
		/* height: 740px; */
		background-color: #fff;
		padding: 5px;
		display: flex;
		flex-direction: column;
	}

	.right-box {
		width: 1340px;
		margin-left: 10px;
		background-color: #fff;
	}
	
</style>